import { sdkOpenLink } from '@utiles/sdkCtrl';
import { useRouter } from 'vue-router';
import { useBaseStore } from '@store/base';
import { computed } from 'vue';

export default function useArticleJumpLink() {
  const router = useRouter();
  const base = useBaseStore();
  const moduleConfig = computed(() => base.moduleConfig);
  /**
   * id：文章groupId
   * articleType - 文章类别：1普通文章、2外链文章
   * target - 外链文章打开方式：1 webview打开，2 浏览器打开
   * redirectLink:外链链接
   * source:来源
   */
  const articleJumpLink = ({
    id,
    articleType,
    target,
    redirectLink,
    source,
  }) => {
    // 非外链打开
    if (articleType == 1) {
      router.push({
        path: '/articledetail',
        query: {
          groupId: id,
          source: source,
        },
      });
      return;
    }

    // 外链打开
    if (redirectLink) {
      // 如果为跳转模块页面
      if (redirectLink.indexOf('jumpModulePage=1') > -1) {
        const urlParams = new URLSearchParams(redirectLink);
        const module = urlParams.get('module');
        const classId = urlParams.get('classId');
        if (module) {
          const findModule = moduleConfig.value.find(
            (item) => item.MODULE_ENNAME === module
          );
          if (findModule) {
            const { MODULE_PATH } = findModule;
            router.push({
              path: MODULE_PATH,
              query: {
                classId: classId || '',
                source: source || '',
              },
            });
          }
        }
        return;
      }

      sdkOpenLink({
        link: redirectLink,
        openWay: +target,
        loginDir: '1',
        appendParams: '1',
        source: source || '',
      });
    }
  };

  return {
    articleJumpLink,
  };
}
